/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import MuiButton from '@material-ui/core/Button';

export const shouldForwardProp = (props, prop) => !props.includes(prop);

const Button = styled(MuiButton, {
  shouldForwardProp: (prop) => shouldForwardProp(['size'], prop),
})(({ size, theme }) => {
  let largeProps = {};
  let darkProps = {};
  if (size === 'large') {
    largeProps = {
      paddingTop: theme.spacing(1.75),
      paddingBottom: theme.spacing(1.75),
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
      borderRadius: 40,
      fontSize: theme.typography.body1.fontSize,
    };
  }
  if (theme.palette.type === 'dark') {
    darkProps = {
      border: `1px solid ${theme.palette.common.coral}`,
      '&:hover': {
        border: `1px solid ${theme.palette.common.coral}`,
      },
    };
  }
  return {
    border: `1px solid ${theme.palette.common.midBlue}`,
    textTransform: 'none',
    color: theme.palette.common.white,
    ...largeProps,
    ...darkProps,
  };
});

export default Button;
